import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {Select} from 'antd'

@observer
class Operator extends Component {
  handleChange = (value) => {
    this.props.condition.change('op', value)
  }
  getOptions = () => {
    const {tagValueType} = this.props.condition
    if (tagValueType === 'string') {
      return [
        {value: 'eq', label: 'Is'}
      ]
    } else {
      return [
        {value: 'gt', label: 'Greater than'},
        {value: 'gte', label: 'Greater than or equal to'},
        {value: 'eq', label: 'Is'},
        {value: 'lte', label: 'Less than or equal to'},
        {value: 'lt', label: 'Less than'}
      ]
    }
  }
  render() {
    const op = this.props.condition.op
    return(
      <div>
        <label>Operator:</label>
        <Select
          value={op}
          onChange={this.handleChange}
          size='large'
        >
          {this.getOptions().map(option => (
            <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
          ))}
        </Select>
      </div>
    )
  }
}

export default Operator
